export default {
    "types": {
        "plan": {
            "showName": "Постановка целей",
            "selected": false,
            "order": 1,
            "autostart": false,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "hideDates": false
        },
        "intermediate_assessment": {
            "showName": "Промежуточные результаты",
            "selected": false,
            "order": 2,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "hideDates": false
        },
        "assessment": {
            "showName": "Оценка в конце года",
            "selected": false,
            "order": 3,
            "canManageElementsBeforeDateStart": false,
            "canManageElementsAfterDateEnd": false,
            "hideDates": false
        }
    }
}